export const SET_VIDEO_PATH = 'SET_VIDEO_PATH';
export const SET_VIDEO_OPEN = 'SET_VIDEO_OPEN';
export const SET_MEDIA_PROPERTIES = 'SET_MEDIA_PROPERTIES';

export const SET_CURRENT_AUDIO_TRACK_SOUNDFIELD = 'SET_CURRENT_AUDIO_TRACK_SOUNDFIELD';

export const TOGGLE_AUDIO_METERS = 'TOGGLE_AUDIO_METERS';
export const TOGGLE_ALPHA_CHANNEL = 'TOGGLE_ALPHA_CHANNEL';
export const TOGGLE_FRAME_METADATA = 'TOGGLE_FRAME_METADATA';
export const TOGGLE_WAVEFORM = 'TOGGLE_WAVEFORM';
export const SET_OVERLAY_FLAGS = 'SET_OVERLAY_FLAGS';

export const SET_VIDEO_CURRENT_TIME = 'SET_VIDEO_CURRENT_TIME';
export const SET_VIDEO_DURATION = 'SET_VIDEO_DURATION';
export const SET_VIDEO_CURRENT_TIMECODE = 'SET_VIDEO_CURRENT_TIMECODE';

export const SET_TIME_DISPLAY_SOURCE = 'SET_TIME_DISPLAY_SOURCE';

export const SET_EXPERIMENTAL_FEATURES = 'SET_EXPERIMENTAL_FEATURES';
export const SET_IS_QUICK_VIEW = 'SET_IS_QUICK_VIEW';
export const SET_FPS = 'SET_FPS';

export const SET_FRAME = 'SET_FRAME';
export const SET_UI_ACCESS = 'SET_UI_ACCESS';
export const SET_FILE_TABLE_SORT = 'SET_FILE_TABLE_SORT';
export const SET_VIDEO_CONTROLLER = 'SET_VIDEO_CONTROLLER';
export const SET_VIDEO_ELEMENT = 'SET_VIDEO_ELEMENT';
export const SET_USER_SUBTITLES = 'SET_USER_SUBTITLES';
export const SET_USER_START_FRAME = 'SET_USER_START_FRAME';
export const SET_ACTIVE_ITEMS = 'SET_ACTIVE_ITEMS';
export const SET_OPEN_ITEMS = 'SET_OPEN_ITEMS';
export const SET_FILE_BROWSER_FILTER_VALUES = 'SET_FILE_BROWSER_FILTER_VALUES';
export const SET_FILE_BROWSER_FILTER_TYPE = 'SET_FILE_BROWSER_FILTER_TYPE';
export const SET_AUDIO_PATHS_CONFIG = 'SET_AUDIO_PATHS_CONFIG';
export const SET_CURRENT_SIDECAR_AUDIO_PATHS = 'SET_CURRENT_SIDECAR_AUDIO_PATHS';
export const SET_CONTAINS_ALPHA_CHANNEL = 'SET_CONTAINS_ALPHA_CHANNEL';

export const SET_VIDEO_TIMECODE_SOURCES = 'SET_VIDEO_TIMECODE_SOURCES';
export const SET_SHOW_TIMECODE_OVERLAY = 'SET_SHOW_TIMECODE_OVERLAY';

export const SET_VIDEO_IS_LOADING = 'SET_VIDEO_IS_LOADING';
export const SET_VIDEO_HAS_FAILED_LOADING = 'SET_VIDEO_HAS_FAILED_LOADING';
export const SET_VIDEO_CAN_PLAY = 'SET_VIDEO_CAN_PLAY';
export const SET_VIDEO_IS_MUTED = 'SET_VIDEO_IS_MUTED';
export const SET_VIDEO_VOLUME = 'SET_VIDEO_VOLUME';
export const SET_VIDEO_IS_PAUSED = 'SET_VIDEO_IS_PAUSED';
export const SET_VIDEO_IS_ON_REPEAT = 'SET_VIDEO_IS_ON_REPEAT';
export const SET_VIDEO_IS_REWINDING = 'SET_VIDEO_IS_REWINDING';
export const SET_VIDEO_IS_LIVE = 'SET_VIDEO_IS_LIVE';
export const SET_VIDEO_PLAYBACK_RATE = 'SET_PLAYBACK_RATE';
export const SET_VIDEO_FIRST_TIMECODE = 'SET_VIDEO_FIRST_TIMECODE';
export const SET_VIDEO_LAST_TIMECODE = 'SET_VIDEO_LAST_TIMECODE';
export const SET_VIDEO_IN = 'SET_VIDEO_IN';
export const SET_VIDEO_OUT = 'SET_VIDEO_OUT';
export const SET_VIDEO_OVERLAYS = 'SET_VIDEO_OVERLAYS';
export const SET_VIDEO_SIMULATE_ALPHA = 'SET_VIDEO_SIMULATE_ALPHA';
export const SET_VIDEO_IS_FULLSCREEN = 'SET_VIDEO_IS_FULLSCREEN';
export const SET_VIDEO_FIRST_FRAME = 'SET_VIDEO_FIRST_FRAME';
export const SET_VIDEO_FRAME_COUNT = 'SET_VIDEO_FRAME_COUNT';

export const SET_AUDIO_METER = 'SET_AUDIO_METER';
export const SET_AUDIO_METERS = 'SET_AUDIO_METERS';
export const CLEAR_AUDIO_METERS = 'CLEAR_AUDIO_METERS';
export const SET_AUDIO_CHANNEL_COUNT = 'SET_AUDIO_CHANNEL_COUNT';
export const SET_AUDIO_METERS_OFFSET = 'SET_AUDIO_METERS_OFFSET';
export const SET_PEAK_MODE = 'SET_PEAK_MODE'
export const SET_FRAME_METADATA = 'SET_FRAME_METADATA';

export const SET_ANNOTATIONS_CONNECTION = 'SET_ANNOTATIONS_CONNECTION';

export const SET_PLUGINS_CONNECTION = 'SET_PLUGINS_CONNECTION';
export const SET_PLUGIN_SCHEMAS = 'SET_PLUGIN_SCHEMAS';
export const SET_PLUGIN_MODEL = 'SET_PLUGIN_MODEL';
export const SET_PLUGIN_SCHEMA = 'SET_PLUGIN_SCHEMA';
export const SET_PLUGIN_SELECTION = 'SET_PLUGIN_INDEX';
export const SET_CLIP_LIST_OUTPUTS = 'SET_CLIP_LIST_OUTPUTS';
export const SET_CLIP_LIST_OUTPUT_CONFIGURATION = 'SET_CLIP_LIST_OUTPUT_CONFIGURATION';
export const SET_SELECTED_CLIP_LIST_OUTPUT = 'SET_SELECTED_CLIPLIST_OUTPUT';

export const SET_HISTORY = 'SET_HISTORY';

export const SET_USER_AUTHENTICATION = 'SET_USER_AUTHENTICATION';
export const SET_USER_NAME = 'SET_USER_NAME';
export const SET_USER_ACCESS = 'SET_USER_ACCESS';

export const SET_LICENSE_IS_ACTIVE = 'SET_LICENSE_IS_ACTIVE';
export const SET_LICENSE_STATE = 'SET_LICENSE_STATE';
export const SET_LICENSE_KEY = 'SET_LICENSE_KEY';
export const SET_LICENSE_EXPIRATION = 'SET_LICENSE_EXPIRATION';
export const SET_LICENSE_ENTITLEMENTS = 'SET_LICENSE_ENTITLEMENTS';
export const SET_INSTALLATION_ID = 'SET_INSTALLATION_ID';
export const SET_WAITING_FOR_LICENSE_ACTIVATION = 'SET_WAITING_FOR_LICENSE_ACTIVATION';
export const SET_WAITING_FOR_LICENSE_DEACTIVATION = 'SET_WAITING_FOR_LICENSE_DEACTIVATION';

export const SET_SNACK = 'SET_SNACK';

export const SET_FULLSCREEN_ELEMENT = 'SET_FULLSCREEN_ELEMENT';
export const SET_FILE_BROWSER_IS_OPEN = 'SET_FILE_BROWSER_IS_OPEN';
export const SET_FILE_BROWSER_IS_HIDDEN = 'SET_FILE_BROWSER_IS_HIDDEN';
export const SET_QUICKVIEW_IS_ENABLED = 'SET_QUICKVIEW_IS_ENABLED';
export const SET_INFO_COLUMN_SPLIT = 'SET_INFO_COLUMN_SPLIT';
export const SET_MEDIA_COLUMN_SPLIT = 'SET_MEDIA_COLUMN_SPLIT';
export const SET_COLUMNS_SPLIT = 'SET_COLUMNS_SPLIT';
export const SET_TOP_TABS = 'SET_TOP_TABS';
export const SET_BOTTOM_TABS = 'SET_BOTTOM_TABS';
export const SET_ANNOTATION_TOOLS_ARE_SHOWN = 'SET_ANNOTATION_TOOLS_ARE_SHOWN';
export const SET_ANNOTATION_TOOL = 'SET_ANNOTATION_TOOL';
export const SET_ANNOTATION_TOOLS_COLOR = 'SET_ANNOTATION_TOOLS_COLOR';
export const SET_ANNOTATION_SHAPES_SELECTED = 'SET_ANNOTATION_SHAPES_SELECTED';
export const SET_ANNOTATION_BEING_EDITED = 'SET_ANNOTATION_BEING_EDITED';
export const SET_REPLY_BEING_EDITED = 'SET_REPLY_BEING_EDITED';
export const SET_IS_WAVEFORM_FLAG_CLICKED = 'SET_IS_WAVEFORM_FLAG_CLICKED';
export const SET_IS_ANNOTATION_FLAG_CLICKED = 'SET_IS_ANNOTATION_FLAG_CLICKED';
export const SET_WAVEFORM_ZOOM_LEVEL = 'SET_ZOOM_LEVEL';

export const SET_QUICKVIEW_ELEMENT = 'SET_QUICKVIEW_ELEMENT';
export const SET_QUICKVIEW_CONTROLLER = 'SET_QUICKVIEW_CONTROLLER';
export const SET_QUICKVIEW_PATH = 'SET_QUICKVIEW_PATH';
export const SET_QUICKVIEW_STATUS = 'SET_QUICKVIEW_STATUS';

export const SET_INDEXER_CONNECTION = 'SET_INDEXER_CONNECTION';
export const SET_INDEXER_PROGRESS = 'SET_INDEXER_PROGRESS';
export const SET_SELECTED_WAVEFORM_MARKS = 'SET_SELECTED_WAVEFORM_MARKS';
export const SET_ROTATION = 'SET_ROTATION'

export const SET_SCOPES_ELEMENT = 'SET_SCOPES_ELEMENT';
export const SET_SCOPES_CONTROLLER = 'SET_SCOPES_CONTROLLER';
export const SET_SCOPES_CAN_PLAY = 'SET_SCOPES_CAN_PLAY';
export const SET_SCOPES_TYPE = 'SET_SCOPES_TYPE';
export const SET_SCOPES_GRATICULE = 'SET_SCOPES_GRATICULE';

export const SET_CLIPS = 'SET_CLIPS';
export const SET_STAGED_CLIP = 'SET_STAGED_CLIP';
export const SET_CLIPS_ELEMENT = 'SET_CLIPS_ELEMENT';

export const SET_ANNOTATIONS = 'SET_ANNOTATIONS';
export const SET_WATCHERS = 'SET_WATCHERS';
export const SET_ANNOTATIONS_REFERENCES = 'SET_ANNOTATIONS_REFERENCES';
export const SET_PRESET_ANNOTATION_TIME = 'SET_PRESET_ANNOTATION_TIME';

export const SET_FILE_BROWSER_PATH = 'SET_FILE_BROWSER_PATH';
export const SET_FILE_BROWSER_ENTRIES = 'SET_FILE_ENTRIES';
export const SET_FILE_BROWSER_ORDER = 'SET_FILE_BROWSER_ORDER';
export const SET_FILE_BROWSER_FILTER = 'SET_FILE_BROWSER_FILTER';
export const SET_FILE_BROWSER_FAVORITES = 'SET_FILE_BROWSER_FAVORITES';
export const SET_FILE_BROWSER_IS_BUSY = 'SET_FILE_BROWSER_IS_BUSY';